import Select, { components } from 'react-select'
import { ReactComponent as ChevronDown } from '../../../svg/chevron-down.svg'
import Skeleton from 'react-loading-skeleton'
import { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { authCurrencySelector } from '../../../redux/selectors/authSelectors'
import { cartCurrencyFromQuerySelector } from '../../../redux/selectors/cartSelector'
import { filtersCurrenciesSelector } from '../../../redux/selectors/filtersSelector'
import { setCurrency } from '../../../redux/actions/cartAction'

function CurrencyFilterRow ({
    currenciesList,
    cart,
    setCurrency,
    pageLoading

}) {

    const authCurrency = useSelector((state) => authCurrencySelector(state));
    const currencyFromQuery = useSelector((state) => cartCurrencyFromQuerySelector(state));

    useEffect(() => {
        const hasCurrencies = currenciesList && Object.keys(currenciesList).length > 0;
        if (!hasCurrencies) return;

        const selectedCurrency =
            currenciesList[currencyFromQuery] ??
            currenciesList[authCurrency] ??
            currenciesList['USD'];

        setCurrency(selectedCurrency);
    }, [currenciesList, currencyFromQuery, authCurrency]);


    const DropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <ChevronDown className="icon"/>
        </components.DropdownIndicator>
    )

    return (
        <div className="section__row">
            <ul className="filter__list filter__list--currency">
                <li className="section__cell filter__item filter__item--currency">
                    {pageLoading ? (
                        <Skeleton
                            containerClassName="filter__selector ml-2"
                            height={32}
                        />
                    ) : (
                        <>
                            <label
                                htmlFor="currencyList"
                                className="filter__label text-5"
                            >
                                Currency
                            </label>
                            <Select
                                id="currencyList"
                                options={Object.values(currenciesList ?? [])?.map((currency) => ({
                                    value: currency.currency,
                                    label: currency.currency
                                }))}
                                className="filter__selector ml-2"
                                classNamePrefix="filter"
                                isSearchable
                                components={{ DropdownIndicator }}
                                onChange={(e) => {
                                    setCurrency(currenciesList[e?.value])
                                }}
                                value={{
                                    value: cart?.currency?.currency,
                                    label: cart?.currency?.currency
                                }}
                            />
                        </>
                    )}
                </li>
            </ul>
        </div>
    )
}

const mapStateToProps = (state) => ({
    currenciesList: filtersCurrenciesSelector(state),
})

const mapDispatchToProps = (dispatch) => ({
    setCurrency: (currency) => dispatch(setCurrency(currency))
})

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyFilterRow)
